import React, { useContext, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { NotificationsProvider } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter } from 'react-router-dom';

import { ContextProvider } from './contexts';
import { AuthContext } from './contexts/auth';
import { ThemeProvider } from './theme';
import { ColorSchemeProvider } from './color-scheme';
import { ErrorBoundaryFallback } from './components/error-boundary-fallback';
import { Router } from './router';
import config from './config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createFallback = (props: any) => <ErrorBoundaryFallback {...props} />;

const App: React.FC = () => {
  const { authState } = useContext(AuthContext);

  useEffect(() => {
    if (authState.isAuth && authState.user) {
      Sentry.setUser({
        id: authState.user.id,
        email: authState.user.email,
        username: `${authState.user.firstName} ${authState.user.lastName}`,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [authState.isAuth, authState.user]);

  return (
    <>
      <Router />
    </>
  );
};

export const AppWithProviders: React.FC = () => (
  <BrowserRouter>
    <ContextProvider>
      <ColorSchemeProvider>
        <ThemeProvider>
          <NotificationsProvider>
            <ModalsProvider>
              <GoogleOAuthProvider clientId={config.googleOAuthClientId}>
                <Sentry.ErrorBoundary fallback={createFallback}>
                  <App />
                </Sentry.ErrorBoundary>
              </GoogleOAuthProvider>
            </ModalsProvider>
          </NotificationsProvider>
        </ThemeProvider>
      </ColorSchemeProvider>
    </ContextProvider>
  </BrowserRouter>
);
